import { isClinicCustomerNotFound } from './apiErrors'

// `from` records which screen the user bounced out of, so /sync-rewards knows where
// they came from.
const SYNC_FROM = {
  loginWithPhone: '/user/login-with-phone',
  loginOtp: '/otp',
  userVerify: '/user/verify',
}

const syncRewardsPath = (from) => `/sync-rewards?from=${from}`

/**
 * Two failures send the user to the rewards-sync flow instead of showing an error:
 * the clinic has no customer record for this phone number, or the API blew up (5xx)
 * and we cannot tell them anything useful anyway.
 */
const shouldRedirectToSyncRewards = (err) => {
  if (isClinicCustomerNotFound(err?.detail)) return true
  const status = Number(err?.status)
  return Number.isFinite(status) && status >= 500
}

export { SYNC_FROM, syncRewardsPath, shouldRedirectToSyncRewards }
